import { useNavigate } from "react-router-dom";
import Header from "./shared/header";
import Footer from "./shared/footer";
import MobileLayout from "./shared/mobile_layout";
import { useState, useEffect } from "react";

import DesktopLayout from "./shared/desktop_layout";
import FeaturesSection from "./shared/outcomesWeDeliver/featuresSection";
import CaseStudies from "./shared/outcomesWeDeliver/CaseStudies";

function RevenueGrowth() {
  const navigation = useNavigate();
  const features = [
    {
      title: "Customer Lifecycle Management (CLM)",
      description:
        "Personalized, insight-driven campaigns from onboarding to churn prevention - using proven playbooks and journey templates.",
      image: "https://via.placeholder.com/200x150",
    },
    {
      title: "Dynamic Pricing & Personalization",
      description:
        "Tailor offers, prices, and experiences in real time using predictive models and GenAI - across app, web, and outbound channels.",
      image: "https://via.placeholder.com/200x150",
    },
    {
      title: "Agentic CVM & Telemarketing",
      description:
        "Deploy outbound AI coworkers for renewals, winbacks, and upsell - increasing coverage and conversion at lower cost.",
      image: "https://via.placeholder.com/200x150",
    },
    {
      title: "Omnichannel Campaign Orchestration",
      description:
        "Coordinate SMS, WhatsApp, email, and call center outreach for consistent, targeted communication - maximizing ROI per impression.",
      image: "https://via.placeholder.com/200x150",
    },
    {
      title: "Data-Triggered Promotions & Nudges",
      description:
        "Move beyond calendar-based blasts to behavior-driven engagement - based on churn risk, value segmentation, or lifecycle moments.",
      image: "https://via.placeholder.com/200x150",
    },
  ];

  const caseStudiesCards = [
    {
      text: "From 1M to 30M: Scaling Telco CVM with AWS MLOps",
      description:
        "Replaced manual, intuition-led campaigns with a cloud-native MLOps engine for real-time, ML-powered customer engagement-boosting campaign efficiency from 7% to 55% and doubling ARPU.",
      image:
        "/images/revenue-growth/OBZ Case Study Images Outcomes Revenue.png",
      slug: "scaling-cvm-with-aws-mlops",
    },
    {
      text: "Boosting Conversions with a Multilingual Sales Voice Agent",
      description:
        "Deployed an outbound AI agent to upsell broadband plans via voice calls in both English and Tagalog using real-time sentiment detection and personalized offers. Delivered a 50% reduction in cost per conversion and 12% uplift in daily conversions.",
      image:
        "/images/revenue-growth/OBZ Case Study Images Outcomes Revenue2.png",
      slug: "agentic-voice-ai-broadband-upsell",
    },
    {
      text: "ML-Driven NBO System Scales Revenue for Telco",
      description:
        "Built and scaled an ML-driven Next-Best-Offer (NBO) system across 6M+ subscribers driving 2X campaign efficiency, 2X improvement in ARPU, and 1.7X uplift in per subscriber revenue compared to legacy rule-based campaigns.",
      image:
        "/images/revenue-growth/OBZ Case Study Images Outcomes Revenue3.png",
      slug: "ml-driven-nbo-for-cvm",
    },
  ];

  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const Layout = ({ children, backgroundColor }) => {
    return screenSize <= 768 ? (
      <MobileLayout backgroundColor={backgroundColor}>{children}</MobileLayout>
    ) : (
      <DesktopLayout backgroundColor={backgroundColor}>
        {children}
      </DesktopLayout>
    );
  };

  return (
    <div>
      <Layout>
        <Header color="rgba(11, 21, 76, 1)" />
      </Layout>
      <Layout backgroundColor="black">
        <div className="w-full mt-10 py-16 lg:py-10">
          <div className="w-[88%] lg:w-[80%] mx-auto">
            {/* Header Section */}
            <div className="mb-12 lg:mb-7">
              <h2 className="text-[32px] lg:text-[48px] xl:text-[56px] text-white RoobertLight leading-[120%] mb-4">
                Revenue Growth
              </h2>
              <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-white RoobertMedium leading-[120%] mb-8">
                Turn your data into revenue - predictably and at scale.
              </h3>
            </div>

            {/* Body Text */}
            <div className="mb-12 lg:mb-8 space-y-5">
              <p className="text-[16px] lg:text-[18px] text-white RoobertRegular leading-[140%]">
                We help enterprises activate their data - not just analyze it -
                to unlock measurable top-line growth.From prepaid recharges and
                postpaid upsell in telco, to card acquisition and activation in
                banking, our solutions deliver fast, reliable, and repeatable
                outcomes.
              </p>
              <p className="text-[16px] lg:text-[18px] text-white RoobertRegular leading-[140%]">
                Whether you're looking to improve product uptake, drive
                frequency, or increase value per customer, OBZ combines domain
                expertise with applied ML, GenAI, and a co-development model
                that embeds outcomes into the business.
              </p>
            </div>
            <div className="mb-4 lg:mb-7">
              <FeaturesSection features={features} />
              <h3 className="text-[16px] lg:text-[18px] text-white RoobertRegular leading-[140%]">
                Our modular CVM framework, built from years of delivery across
                ASEAN and ANZ, helps enterprises move from concept to uplift in
                under 12 weeks.
              </h3>
            </div>
          </div>
        </div>
      </Layout>
      <Layout backgroundColor="black">
        <CaseStudies caseStudiesCards={caseStudiesCards} />
      </Layout>
      <Layout>
        <div className="w-full bg-fluoro-green py-16 lg:py-8 min-h-[500px] flex items-center justify-center relative">
          <div className="w-[88%] lg:w-[80%] py-5 px-5 h-full mx-auto relative bg-fluoro-green">
            <div className="mb-12 lg:mb-7 px-6">
              <h2 className="text-[32px] lg:text-[48px] xl:text-[56px] text-[#0A1931] RoobertLight leading-[120%] mb-4">
                Built with You
              </h2>
              <p className="text-[16px] lg:text-[18px] text-[#0A1931] font-bolder RoobertSemiBold leading-[140%] mb-4">
                We embed with internal marketing, analytics, and product teams
                to identify the highest-ROI opportunities, co-design journeys,
                and operationalize ML and GenAI capabilities.
              </p>
              <p className="text-[16px] lg:text-[18px] text-[#0A1931] font-bolder RoobertSemiBold leading-[140%] mb-4">
                The result: scalable engines for growth, not one-off wins.
              </p>
              <div className="flex justify-center mt-6">
                <button
                  className="bg-[#0A1931] text-white px-8 py-4 RoobertSemiBold text-[16px] lg:text-[18px] tracking-wider"
                  onClick={() => navigation("/contact-us")}
                >
                  Start the conversation
                </button>
              </div>
              <div className="border-r-4 border-t-4 border-[#0A1931] absolute top-0 right-0 w-1/4 h-1/2"></div>
              <div className="border-r-4 border-t-4 border-[#0A1931] absolute bottom-0 rotate-180 left-0 w-1/4 h-1/2"></div>
            </div>
          </div>
        </div>
      </Layout>
      <Layout>
        <Footer />
      </Layout>
    </div>
  );
}

export default RevenueGrowth;
